module.exports = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
};
